// extracted by mini-css-extract-plugin
module.exports = {"all_component":"SignIn_all_component__dumme","login_div":"SignIn_login_div__2_DOK","login_form":"SignIn_login_form__3VOWG"};